import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from '@fgb/core';

@Injectable({ providedIn: 'root' })
export class SsoService {
  getThirdPartyCallbackUrl(email: string, userId: string, accountnumber: string): string {
    const params = new HttpParams().set('email', email).set('userId', userId).set('accountnumber', accountnumber);

    return `${config.baseApiUrl}/api/sso/thirdparty/1/111/0/${config.portalUrl}?${params.toString()}`;
  }
}
